export namespace arToysPayments {
    export type IPayment = {
        amount: number
        gold: number
        cdnId: string
        once?: boolean
        toyId?: number
    }

    export type PaymentsIds = '50' | '100' | '350' | '1k' | '3k' | '10k' | '20k' | '50k' // 2

    // mapping for stripe test mode
    export const testModePrices: Record<PaymentsIds, IPayment> = {
        '50': {
            amount: 0.99,
            gold: 50,
            cdnId: 'gold_50',
            once: true
        },
        '100': {
            amount: 4.99,
            gold: 100,
            cdnId: 'gold_100',
            toyId: 578
        },
        '350': {
            amount: 14.99,
            gold: 350,
            cdnId: 'gold_350'
        },
        '1k': {
            amount: 39.99,
            gold: 1000,
            cdnId: 'gold_1k'
        },
        '3k': {
            amount: 99.99,
            gold: 3000,
            cdnId: 'gold_3k',
            toyId: 646
        },
        '10k': {
            amount: 299.99,
            gold: 10000,
            cdnId: 'gold_10k',
            toyId: 621
        },
        '20k': {
            amount: 499.99,
            gold: 20000,
            cdnId: 'gold_20k'
        },
        '50k': {
            amount: 999.99,
            gold: 50000,
            cdnId: 'gold_50k'
        }
    } as const // 3

    // mapping for stripe production mode
    export const prices: Record<PaymentsIds, IPayment> = {
        '50': {
            amount: 0.99,
            gold: 50,
            cdnId: 'gold_50'
        },
        '100': {
            amount: 4.99,
            gold: 100,
            cdnId: 'gold_100'
        },
        '350': {
            amount: 14.99,
            gold: 350,
            cdnId: 'gold_350'
        },
        '1k': {
            amount: 39.99,
            gold: 1000,
            cdnId: 'gold_1k'
        },
        '3k': {
            amount: 99.99,
            gold: 3000,
            cdnId: 'gold_3k'
        },
        '10k': {
            amount: 299.99,
            gold: 10000,
            cdnId: 'gold_10k'
        },
        '20k': {
            amount: 499.99,
            gold: 20000,
            cdnId: 'gold_20k'
        },
        '50k': {
            amount: 999.99,
            gold: 50000,
            cdnId: 'gold_50k'
        }
    } as const // 3

    // ruby images
    //     ruby_25
    //     ruby_50
    //     ruby_100
    //     ruby_500
    //     ruby_1k
    //     ruby_2k
    //     ruby_20k
    //     ruby_1
}
